import { offerAccepted } from "./Action";
import {
  ACCEPT_OFFER,
  ADD_DOCUMENT_DETAILS,
  ADD_EDUCATIONDETAILS,
  ADD_EXPERIENCEDETAILS,
  ADD_FAMILYDETAILS,
  APPROVE_NEWHIRE,
  CHANGE_PASSWORD,
  CREATE_USER,
  DESIGNATION_LIST,
  DOCUMENT_LIST,
  EDUCATION_DETAILS,
  EMP_USER_DETAILS,
  EMPLOYEE_LIST,
  EXPERIENCE_DETAILS,
  FAMILY_DETAILS,
  FORGOT_PASSWORD,
  INITIATE_NEWHIRE,
  NEWHIRE_USER_DETAILS,
  OFFER_DETAILS,
  ONBOARD_USER_DETAILS,
  PERSONAL_DETAILS,
  ROLE_LIST,
  UPDATE_ONBOARDING,
  USER_DETAILS,
  USER_DOCUMENT_LIST,
  USER_LIST,
  VALIDATE_USER,
  EXIT_EMPLOYEE,
  NEW_HIRE_TRANSACTION,
  OFFER_ACCEPTED,
  CONTRACT_EMPLOYEE_LIST,
  SUPPORT_EMPLOYEE_LIST,
  EMPLOYEE_DATA,
  EMPLOYEE_DATA_EXCEL,
  CONTRACT_DATA_EXCEL,
  SUPPORT_DATA_EXCEL,
  ALL_EMPLOYEE_LIST,
  INSTANT_ONBOARD,
} from "./ActionType";

const initialValue = {
  desiglist: [],
  userlist: [],
  addfamily: null,
  addeducation: null,
  addexperience: null,
  adddocument: null,
  validationStatus: null,
  statusDesc: null,
  field: "",
  createUserData: "",
  personalDetails: [],
  familyListDetails: [],
  educationListDetails: [],
  experienceListDetails: [],
  documentLists: [],
  initiatenewhire: null,
  instantOnboard: [],
  updateonboard: null,
  userDetails: [],
  newHireUserDetails: [],
  empUserDetails: [],
  rolelists: [],
  offerDetails: null,
  acceptoffer: null,
  userdocslist: [],
  approvenewhire: null,
  employeelist: [],
  onBoardUserDetails: [],
  changepwd: [],
  forgotPwd: [],
  exitEmployee: [],
  newHireTransactionList: [],
  supportEmployeeList: [],
  allEmployees: [],
  employeeData: [],
  employeeDataExcel: [],
  supportDataExcel: [],
  contractDataExcel: [],
};

export const newHireReducer = (store = initialValue, { type, payload }) => {
  if (type === DESIGNATION_LIST) {
    return {
      ...store,
      desiglist: payload,
    };
  } else if (type === USER_LIST) {
    return {
      ...store,
      userlist: payload.userList || [],
    };
  } else if (type === ADD_FAMILYDETAILS) {
    return {
      ...store,
      addfamily: payload,
    };
  } else if (type === ADD_EDUCATIONDETAILS) {
    return {
      ...store,
      addeducation: payload,
    };
  } else if (type === ADD_EXPERIENCEDETAILS) {
    return {
      ...store,
      addexperience: payload,
    };
  } else if (type === ADD_DOCUMENT_DETAILS) {
    return {
      ...store,
      adddocument: payload,
    };
  } else if (type === VALIDATE_USER) {
    return {
      ...store,
      validationStatus: payload.statusCode,
      statusDesc: payload.statusDesc,
      field: payload.field,
    };
  } else if (type === CREATE_USER) {
    return {
      ...store,
      createUserData: payload,
    };
  } else if (type === PERSONAL_DETAILS) {
    return {
      ...store,
      personalDetails: payload.personalDetails || [],
    };
  } else if (type === FAMILY_DETAILS) {
    return {
      ...store,
      familyListDetails: payload.familyDetails || [],
    };
  } else if (type === EDUCATION_DETAILS) {
    return {
      ...store,
      educationListDetails: payload.educationDetails || [],
    };
  } else if (type === EXPERIENCE_DETAILS) {
    return {
      ...store,
      experienceListDetails: payload.experienceDetails || [],
    };
  } else if (type === DOCUMENT_LIST) {
    return {
      ...store,
      documentLists: payload.documentDetails || [],
    };
  } else if (type === USER_DOCUMENT_LIST) {
    return {
      ...store,
      userdocslist: payload.documentDetails || [],
    };
  } else if (type === INITIATE_NEWHIRE) {
    return {
      ...store,
      initiatenewhire: payload,
    };
  } else if (type === UPDATE_ONBOARDING) {
    return {
      ...store,
      updateonboard: payload,
    };
  } else if (type === USER_DETAILS) {
    return {
      ...store,
      userDetails: payload.user || [],
    };
  } else if (type === NEWHIRE_USER_DETAILS) {
    return {
      ...store,
      newHireUserDetails: payload.user || [],
    };
  } else if (type === EMP_USER_DETAILS) {
    return {
      ...store,
      empUserDetails: payload.user || [],
    };
  } else if (type === ONBOARD_USER_DETAILS) {
    return {
      ...store,
      onBoardUserDetails: payload.user || [],
    };
  } else if (type === ROLE_LIST) {
    return {
      ...store,
      rolelists: payload.roleList || [],
    };
  } else if (type === OFFER_DETAILS) {
    return {
      ...store,
      offerDetails: payload,
    };
  } else if (type === ACCEPT_OFFER) {
    return {
      ...store,
      acceptoffer: payload,
    };
  } else if (type === APPROVE_NEWHIRE) {
    return {
      ...store,
      approvenewhire: payload,
    };
  } else if (type === EMPLOYEE_LIST) {
    return {
      ...store,
      employeelist: payload || [],
    };
  } else if (type === CONTRACT_EMPLOYEE_LIST) {
    return {
      ...store,
      contractEmployeeList: payload || [],
    };
  } else if (type === CHANGE_PASSWORD) {
    return { ...store, changepwd: payload || [] };
  } else if (type === FORGOT_PASSWORD) {
    return { ...store, forgotPwd: payload || [] };
  } else if (type === EXIT_EMPLOYEE) {
    return {
      ...store,
      exitEmployee: payload || [],
    };
  } else if (type === NEW_HIRE_TRANSACTION) {
    return {
      ...store,
      newHireTransactionList: payload.newHireTransactionDtoList || [],
    };
  } else if (type === OFFER_ACCEPTED) {
    return {
      ...store,
      offerAccepted: payload || [],
    };
  } else if (type === SUPPORT_EMPLOYEE_LIST) {
    return {
      ...store,
      supportEmployeeList: payload || [],
    };
  } else if (type === EMPLOYEE_DATA) {
    return {
      ...store,
      employeeData: payload || [],
    };
  } else if (type === EMPLOYEE_DATA_EXCEL) {
    return {
      ...store,
      employeeDataExcel: payload || [],
    };
  } else if (type === SUPPORT_DATA_EXCEL) {
    return {
      ...store,
      supportDataExcel: payload || [],
    };
  } else if (type === CONTRACT_DATA_EXCEL) {
    return {
      ...store,
      contractDataExcel: payload || [],
    };
  } else if (type === ALL_EMPLOYEE_LIST) {
    return {
      ...store,
      allEmployees: payload || [],
    };
  } else if (type === INSTANT_ONBOARD) {
    return {
      ...store,
      instantOnboard: payload,
    };
  }

  return store;
};
